import React from "react";
import "./platform-aurora.css";

/**
 * Fixed decorative aurora mesh behind authenticated app content.
 * Light-mode adaptation of the login page gradient system.
 */
export default function PlatformAurora() {
  return (
    <div className="k-aurora" aria-hidden="true">
      <div className="k-aurora__mesh" />
      <div className="k-aurora__blob k-aurora__blob--1" />
      <div className="k-aurora__blob k-aurora__blob--2" />
      <div className="k-aurora__blob k-aurora__blob--3" />
      <div className="k-aurora__blob k-aurora__blob--4" />
    </div>
  );
}
